<template>
  <transition name="fade">
    <div v-show="showVerificationRequired" class="modal-overlayfrombottomblur" style="z-index: 999;">
      <div class="modal" style="padding-top: 3vh; padding-bottom: 3vh; min-height: 40vh; width: 70%">
        <table border="0" width="80%">
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': fontSizeTitle + 'vh', 'line-height': fontSizeTitleLineHeight + 'vh' }">
                Action required
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': fontSizePopUpMsg + 'vh', 'line-height': fontSizePopUpMsgLineHeight + 'vh', 'padding-top': '2vh' }">
                You need to verify your account in order to continue receiving tips with ThankU.
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': fontSizePopUpMsg + 'vh', 'line-height': fontSizePopUpMsgLineHeight + 'vh', 'padding-top': '2vh' }">
                To verify your account, you will need to upload a form of ID (e.g. passport or driving licence) and a proof of address (e.g. recent utility bill)
              </div>
            </td>
          </tr>
          <tr>
            <td style="height: 10vh">
              <div style="padding-top: 2vh">
                <button class="widebtn" style="width: 60%; height: 6vh;" @click="doVerifyNow">Verify now</button>
              </div>
            </td>
          </tr>
          <tr>
            <td style="height: 10vh">
              <div>
                <button class="widebtn" style="width: 60%; height: 6vh;" @click="doLater">Later</button>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </transition>

  <!-- Later message popup -->
  <transition name="fade">
    <div v-show="showLaterMessage" class="modal-overlayfrombottomblur" style="z-index: 1000;">
      <div class="modal" style="padding-top: 3vh; padding-bottom: 3vh; min-height: 40vh; width: 70%">
        <table border="0" width="80%">
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': fontSizeTitle + 'vh', 'line-height': fontSizeTitleLineHeight + 'vh' }">
                Noted
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': fontSizePopUpMsg + 'vh', 'line-height': fontSizePopUpMsgLineHeight + 'vh', 'padding-top': '2vh' }">
                Please be aware that your clients will not be able to tip you until you verify your account. When you are ready to verify, please come back to your account screen at www.thanku.app.
              </div>
            </td>
          </tr>
          <tr>
            <td style="height: 10vh">
              <div style="padding-top: 2vh">
                <button class="widebtn" style="width: 50%; height: 6vh;" @click="doOkLater">Ok</button>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </transition>
</template>

<script>

import shared from '../shared.js';

export default {
  name: 'VerificationRequiredScreen',
  props: {
    userData: shared.userDataStruct(),
  },
  data() {
    return {
      showVerificationRequired: true,
      showLaterMessage: false,
      fontSizeTitle: 2.7,
      fontSizeTitleLineHeight: 5,
      fontSizePopUpMsg: 2.3,
      fontSizePopUpMsgLineHeight: 3.4
    }
  },
  methods: {
    doVerifyNow() {
      this.showVerificationRequired = false;
      this.userData.nextScreen = 'showPersonalDetails';
      this.$emit('next-action', this.userData);
    },
    
    doLater() {
      this.showVerificationRequired = false;
      this.showLaterMessage = true;
    },
    
    doOkLater() {
      this.showLaterMessage = false;
      this.userData.nextScreen = 'showAccountScreen';
      this.$emit('next-action', this.userData);
    }
  }
}
</script>